import * as Sentry from "@sentry/react";

const EXTENSION_ID = import.meta.env.VITE_TREND_ROCKET_EXTENSION_ID;

export enum ChromeExtensionEventType {
  LOG_IN = "LOG_IN",
  LOG_OUT = "LOG_OUT",
}

type ChromeExtensionMessage = {
  event: ChromeExtensionEventType;
  data: any;
};

export const sendChromeExtensionMessage = async (
  message: ChromeExtensionMessage,
) => {
  // @ts-ignore
  if (!window.chrome) {
    return;
  }
  // Working with extension code seems incredibly volatile.
  // If there is no extension running at all then runtime is undefined and will crash chrome.
  // Now catching all errors and returning.
  try {
    // @ts-ignore
    await window?.chrome?.runtime?.sendMessage(EXTENSION_ID, message);
  } catch (e: any) {
    Sentry.withScope((scope) => {
      scope.setTag("module", "sendChromeExtensionMessage");
      scope.setExtra("chromeExtensionMessage", message);
      Sentry.captureException(e);
    });
    return;
  }
};
